import classNames from 'classnames';

import DownloadAudioFile from '../../../media-player/download-audio-file';
import { Pause } from '../../../../general/icon/components/pause';
import { Play } from '../../../../general/icon/components/play';
import { Waveform } from '../waveform/waveform';
import PictureRetinaAssets from '../../../../general/picture-fill-assets/picture-fill-assets';

import styles from './audio-list-item.module.scss';

type AudioListItemProps = {
  title: string;
  subtitle?: string;
  audioSrc: string;
  onClick: () => void;
  playing: boolean;
};

export const AudioListItem = ({
  title,
  subtitle,
  onClick,
  playing,
  audioSrc,
}: AudioListItemProps) => {
  const onDownloadClicked = (evt: React.SyntheticEvent<HTMLDivElement>) => {
    evt.stopPropagation();
  };

  return (
    <div className={styles['audio-item__wrapper']}>
      <button
        onMouseDown={e => e.preventDefault()}
        onClick={onClick}
        className={classNames(
          styles['audio-item'],
          playing
            ? styles['audio-item--playing']
            : styles['audio-item--paused'],
        )}
        aria-label={
          playing
            ? polyglot.t('audio_player.playing.true')
            : polyglot.t('audio_player.play_audio', {
                title,
              })
        }
        aria-live='polite'
      >
        <div className={styles['audio-item__content']}>
          <div className={styles['audio-item__image-container']}>
            <div className={styles['audio-item__image']}>
              <PictureRetinaAssets
                url={require('../../../media-player/assets/audio-player-placeholder-3-x.png')}
                url2x={require('../../../media-player/assets/audio-player-placeholder-3-x@2x.png')}
              />
              <div className={styles['audio-item__play-icon']}>
                <Play />
              </div>
              <div className={styles['audio-item__pause-icon']}>
                <Pause />
              </div>
            </div>
          </div>
          <div className={styles['audio-item__text-container']}>
            <div className={styles['audio-item__text']}>
              <h3 className={styles['audio-item__title']}>{title}</h3>
              <div>
                {!!subtitle && (
                  <p className={styles['audio-item__subtitle']}>{subtitle}</p>
                )}
                {playing && <Waveform />}
              </div>
            </div>
          </div>
        </div>
      </button>
      <div className={styles['audio-item__icon-container']}>
        <div onClick={onDownloadClicked} className={styles['audio-item__icon']}>
          <DownloadAudioFile tooltipTheme='blue' url={audioSrc} title={title} />
        </div>
      </div>
    </div>
  );
};
